// Store

// State
// ....
const state = {
  pasoActivo: 0,
  data: [
    {
      id: 1,
      nombre: 'Datos personales',
      abrevia: 'Datos personales'
    },
    {
      id: 2,
      nombre: 'Datos estudios, experiencia laboral y puesto solicitado',
      abrevia: 'Experiencia laboral y puesto solicitado'
    },
    {
      id: 3,
      nombre: 'Verificar datos',
      abrevia: 'Verificar datos'
    },
    {
      id: 4,
      nombre: 'Listo',
      abrevia: 'Listo'
    }
  ]
}

// Getters
// ...
const getters = {
  getData: (state) => state.data,
  getPasoActivo: (state) => state.pasoActivo,
  getPasoActual: (state) => {
    let pasoActivo = state.pasoActivo;
    let paso = [...state.data].filter(el => el.id==pasoActivo);
    if(paso.length) {
      return paso[ 0 ].abrevia;
    }
    return null;
  }
}

// Mutations
// ...
const mutations = {
  setData: (state, payload) => state.data = payload,
  setPasoActivo: (state, payload) => state.pasoActivo = payload,
}


// Actions
// ...
const actions = {

}



// Export store
// ...
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modulos/Pasos.js